import styled from 'styled-components';

const Wrapper = styled.div`
  border-radius: 3px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
  padding: 0 20px 20px 20px;
`;

export default Wrapper;
